$(function() {

    //When export button clicked...
    $body.on('click', '.export-button', function(e) {
        e.preventDefault();

        //Show loading icon...
        var $icon = $(this).find('.btn__icon > span');
        $icon.addClass('fa-spinner fa-spin');

        //Generate share link and update modal contents
        ajax_call('get', $(this).attr('href'), {}, function(resp) {

            //Revert icon back
            $icon.removeClass('fa-spinner fa-spin');

            //Redirect to file for download
            if(resp.success) {
                window.location = resp.redirect;
            } else {
                alert(resp.message);
            }

        });

    });

});
